"use client";

import { useEffect } from "react";

type ScrollToSectionProps = {
  id?: string;
};

const ScrollToSection = ({ id }: ScrollToSectionProps) => {
  useEffect(() => {
    if (!id) return;
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [id]);

  return <div />;
};

export default ScrollToSection;
